import { Card, CardBody } from '@heroui/react'

export interface MetricCardProps {
  title: string
  value: number | string
  icon: React.ReactNode
  trend?: { value: number; isPositive: boolean }
  color?: string
}

export function MetricCard({ title, value, icon, trend, color = 'var(--fn-primary)' }: MetricCardProps) {
  return (
    <Card>
      <CardBody className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-tf-text-muted mb-1">{title}</p>
            <p className="text-3xl font-bold text-tf-text">{value}</p>
            {trend && (
              <div className="flex items-center gap-1 mt-2">
                <span
                  className={`text-sm font-medium ${ trend.isPositive ? 'text-tf-success' : 'text-tf-critical' }`}
                >
                  {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
                </span>
                <span className="text-xs text-tf-text-muted">vs last period</span>
              </div>
            )}
          </div>
          <div
            className="p-3 rounded-lg"
            style={{ backgroundColor: `${color}15`, color }}
          >
            {icon}
          </div>
        </div>
      </CardBody>
    </Card>
  )
}
